import { Injectable } from '@angular/core';
import { ISignalRService } from './signalr-service.interface';
import { FacialRecognitionService } from '../../account/facial-recognition/facial-recognition.service';
import { HubConnection } from '@microsoft/signalr';
import { MemberQuery } from '../../account/member/member.query';

@Injectable({ providedIn: 'root' })
export class SignalRFacialRecognitionService implements ISignalRService {
  constructor(
    private facialRecognitionService: FacialRecognitionService,
    private memberQuery: MemberQuery
  ) {}

  registerOnServerEvents(connection: HubConnection): void {
    connection.on('FacialImageUploadedViaLink', () => {
      this.facialRecognitionService.fetchFacialImage(this.memberQuery.getUserContext().memberId);
    });
  }
}
